var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":require("../assets/travolta.gif"),"alt":"gif not found"}}),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Nenhum registro encontrado. 😓")])])])
}]

export { render, staticRenderFns }